import api from './AxiosInstance';

export class ExerciceService {


  getAllExercices = async () => {
    try {
      const response = await api.get(`/Compta/Exercices`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);

    }
  };

  getAllExercicesDoc = async () => {
    try {
      const response = await api.get(`/Document/Exercices`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);

    }
  };

  getListExercicePortail = async (id) => {
    try {
      const response = await api.get(`/Document/Exercices2/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);

    }
  };





}